import React, { useState } from "react";
import facebook from "../assests/images/facebook.png";
import twitter from "../assests/images/twitter.png";
import logo from "../assests/images/logo.png";
import GoogleTranslateElement from "./Textmodifier";
import { Link } from "react-router-dom";
import Clock from "../components/Clockbox";
import Translator from "./Translator_textsizechange";
import FontSizeChanger from "../components/Textmodifier";
import menuBar from "../assests/images/mobilemenu.png";

function Header() {
  const [mainMenuTab, setMainMenuTab] = useState(false);
  const [aboutMenuTab, setAboutMenuTab] = useState(false);
  const [plantMenuTab, setPlantMenuTab] = useState(false);
  const [tenderMenuTab, setTenderMenuTab] = useState(false);
  const [subTenderMenuTab, setSubTenderMenuTab] = useState(false);
  const [marketingMenuTab, setMarketingMenuTab] = useState(false);
  const [productMenuTab, setProductMenuTab] = useState(false);
  const [rtiMenuTab, setRtiMenuTab] = useState(false);

  const toggleMainMenuTab = () => {
    setMainMenuTab(!mainMenuTab);
  };

  const toggleAboutMenuTab = () => {
    setAboutMenuTab(!aboutMenuTab);
  };

  const togglePlantMenuTab = () => {
    setPlantMenuTab(!plantMenuTab);
  };

  const toggleTenderMenuTab = () => {
    setTenderMenuTab(!tenderMenuTab);
  };

  const toggleSubTenderMenuTab = () => {
    setSubTenderMenuTab(!subTenderMenuTab);
  };

  const toggleMarketingMenuTab = () => {
    setMarketingMenuTab(!marketingMenuTab);
  };
  const toggleProductMenuTab = () => {
    setProductMenuTab(!productMenuTab);
  };
  const toggleRtiMenuTab = () => {
    setRtiMenuTab(!rtiMenuTab);
  };

  return (
    <header>
      <div className="top-wrp">
        <div className="container">
          <div className="row">
            <div className="clockbox col-lg-3">
              <div id="clockbox">
                <Clock />
              </div>
            </div>


            <div className="col-lg-9">
              <div className="right-section">
                {/* <Translator /> */}
                <li style={{ listStyle: 'none' }}>
                  <div id="google_translate_element">
                    <div class="skiptranslate goog-te-gadget" dir="ltr">
                      <div id=":0.targetLanguage" class="goog-te-gadget-simple" style={{ whiteSpace: 'nowrap' }}>

                      </div>
                    </div>
                  </div>

                </li>


                <div className="text-size-box">
                  <FontSizeChanger />
                </div>
                <div className="social-media">
                  <ul>
                    <li>
                      <a
                        href="https://www.facebook.com/Idpl-Gurgaon-1566111536815917/"
                        target="_blank"
                      >
                        {" "}
                        <img src={facebook} alt="facebook image" />
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/IDPL_INDIA" target="_blank">
                        <img src={twitter} alt="Twitter image" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-5">
            <div className="logo tagline">
              <ul>
                <li style={{ marginRight: "15px" }}>
                  {" "}
                  <a href="/">
                    {" "}
                    <img
                      src={require("../assests/images/logo.png")}
                      className="img-responsive"
                      alt="Logo"
                    />{" "}
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a href="/">
                    <img
                      src="../images/logo1.jpg"
                      className="img-responsive"
                      alt=""
                      title=""
                    />
                  </a>{" "}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="logo-two">
              <a href="pdf/Flag-code-ghar.pdf" target="_blank">
                {" "}
                <img
                  src="http://www.idplindia.in/images/ghar.png"
                  alt="Logo Two"
                />
              </a>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="swachbhrat">
              {" "}
              <img src="../images/swachbhrat.png" alt="Swachh Bharat" />{" "}
            </div>
          </div>
        </div>
      </div>
      <div className="menuwrp">
        <nav className="mbtm0 ">
          <div class="dropdown">
            <button class="dropbtn">
              {" "}
              <Link className="top-heading active" to="/">
                HOME
              </Link>{" "}
            </button>
          </div>

          <div class="dropdown">
            <button class="dropbtn">
              ABOUT <img src={require("../assests/images/drop-arrow.png")} />
            </button>
            <div class="dropdown-content">
              <Link to="/about">ABOUT US</Link>
              <Link to="/vision&mission">VISION & MISSION</Link>
              <Link to="/organization-chart">ORGANIZATION CHART</Link>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              MAIN PLANTS{" "}
              <img src={require("../assests/images/drop-arrow.png")} />
            </button>
            <div class="dropdown-content">
              <Link to="/rishikesh_plant">RISHIKESH PLANT</Link>
              <Link to="/hyderabad-plant">HYDERABAD PLANT</Link>
              <Link to="/gurgaon_plant">GURGAON PLANT</Link>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              SUBSIDIARY UNITS / JOINT VENTURES{" "}
              <img src={require("../assests/images/drop-arrow.png")} />
            </button>
            <div class="dropdown-content">
              <Link to="/chennai-plant">IDPL (TN ) CHENNAI</Link>
              <Link to="/bihar-muzaffarpur-plant">BDOCL MUZZAFARPUR </Link>
              <Link to="/bhubaneswar-orissa-plant">ODCL BHUBNESWAR </Link>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              TENDER <img src={require("../assests/images/drop-arrow.png")} />
            </button>
            <div class="dropdown-content">
              <Link to="/corporate-office">CORPORATE OFFICE</Link>
              <Link to="/gurgaon_plant_tenders">GURGAON PLANT</Link>
              <Link to="/rishikesh_plant_tenders">RISHIKESH PLANT </Link>
              <Link to="/chennai_plant_tenders">CHENNAI PLANT </Link>
              <Link to="/odcl_plant_tenders">ODCL PLANT </Link>
              <Link to="/hyderabad_plant_tenders">HYDERABAD PLANT</Link>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              MARKETING{" "}
              <img src={require("../assests/images/drop-arrow.png")} />
            </button>
            <div class="dropdown-content">
              <Link to="/regional-sales-offices">CORPORATE SALES OFFICE </Link>
              <Link to="/south-zone-office-hyderabad">SOUTH ZONE OFFICE </Link>
              <Link to="/east-zone-office-kolkata"> EAST ZONE OFFICE</Link>
              <Link to="/north-zone-office-gurgaon">NORTH ZONE OFFICE</Link>
              <Link to="/west-zone-office-mumbai"> WEST ZONE OFFICE</Link>
              <Link to="/Lucknow-zone-office"> LUCKNOW ZONE OFFICE</Link>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              PRODUCTS <img src={require("../assests/images/drop-arrow.png")} />{" "}
            </button>
            <div class="dropdown-content">
              <a href="/pdf/In%20House%20Prod..pdf" target="_blank">
                IN HOUSE PRODUCTS
              </a>
              <a href="/pdf/Therapeutical%20Categories.pdf" target="_blank">
                THERAPEUTICAL PRODUCTS
              </a>
              <a
                href="/pdf/Current-Product-Range-PPP-IDPL-01-03-15.pdf"
                target="_blank"
              >
                IDPL GENERIC DRUGS (PPP)
              </a>
              <a
                href="/pdf/Current-Product-Range-Non-PPP-IDPL-01-03-15.pdf"
                target="_blank"
              >
                IDPL GENERIC DRUGS(Non PPP)
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              RTI <img src={require("../assests/images/drop-arrow.png")} />{" "}
            </button>
            <div class="dropdown-content">
              <a href="../pdf/rti-act.pdf" target="_blank">
                RTI Act, 2005
              </a>
              <a
                href="../pdf/CPIO-&-PIO-as-on-09.04.2025.pdf"
                target="_blank"
              >
                CPIO & PIO
              </a>
              <a
                href="pdf/Disclosure-25.02.2025.pdf"
                target="_blank"
              >
                {" "}
                Disclosure under section 4(1)(b) of Right to Information
                Act 2005.
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              {" "}
              <Link to="/career">CAREER</Link>
            </button>
          </div>
          <div class="dropdown">
            <button class="dropbtn">
              {" "}
              <Link to="/contact_us">CONTACT US</Link>
            </button>
          </div>
        </nav>

        {/* section for mobile view */}
        <nav>
          <div className="mobilemenu">
            <div onClick={toggleMainMenuTab} className="mobilemenubutton">
              <button className="mobilebtn">
                <img src={menuBar} alt="" />
              </button>
            </div>
            <nav className={mainMenuTab ? "mainmenu active" : "mainmenu"}>
              <div className="submenu">
                <button className="submenubtn">
                  {" "}
                  <Link to="/" onClick={() => setMainMenuTab(false)}>
                    HOME
                  </Link>{" "}
                </button>
              </div>

              <div>
                <div className="submenu">
                  <button onClick={toggleAboutMenuTab} className="submenubtn">
                    ABOUT{" "}
                    <img
                      src={require("../assests/images/drop-arrow.png")}
                      alt="drop-arrow"
                    />
                  </button>
                  <div
                    className={
                      aboutMenuTab ? "dropcontent active" : "dropcontent"
                    }
                  >
                    <Link to="/about" onClick={() => setMainMenuTab(false)}>
                      ABOUT US
                    </Link>
                    <Link
                      to="/vision&mission"
                      onClick={() => setMainMenuTab(false)}
                    >
                      VISION & MISSION
                    </Link>
                    <Link
                      to="/organization-chart"
                      onClick={() => setMainMenuTab(false)}
                    >
                      ORGANIZATION CHART
                    </Link>
                  </div>
                </div>
                <div className="submenu">
                  <button onClick={togglePlantMenuTab} className="submenubtn">
                    MAIN PLANTS{" "}
                    <img
                      src={require("../assests/images/drop-arrow.png")}
                      alt="drop-arrow"
                    />
                  </button>
                  <div
                    className={
                      plantMenuTab ? "dropcontent active" : "dropcontent"
                    }
                  >
                    <Link
                      to="/rishikesh_plant"
                      onClick={() => setMainMenuTab(false)}
                    >
                      RISHIKESH PLANT
                    </Link>
                    <Link
                      to="/hyderabad-plant"
                      onClick={() => setMainMenuTab(false)}
                    >
                      HYDERABAD PLANT
                    </Link>
                    <Link
                      to="/gurgaon_plant"
                      onClick={() => setMainMenuTab(false)}
                    >
                      GURGAON PLANT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="submenu">
                <button onClick={toggleSubTenderMenuTab} className="submenubtn">
                  SUBSIDIARY UNITS / JOINT VENTURES{" "}
                  <img src={require("../assests/images/drop-arrow.png")} />
                </button>
                <div
                  className={
                    subTenderMenuTab ? "dropcontent active" : "dropcontent"
                  }
                >
                  <Link
                    to="/chennai-plant"
                    onClick={() => setMainMenuTab(false)}
                  >
                    IDPL (TN ) CHENNAI
                  </Link>
                  <Link
                    to="/bihar-muzaffarpur-plant"
                    onClick={() => setMainMenuTab(false)}
                  >
                    BDOCL MUZZAFARPUR{" "}
                  </Link>
                  <Link
                    to="/bhubaneswar-orissa-plant"
                    onClick={() => setMainMenuTab(false)}
                  >
                    ODCL BHUBNESWAR{" "}
                  </Link>
                </div>
              </div>
              <div className="submenu">
                <button onClick={toggleTenderMenuTab} className="submenubtn">
                  TENDER{" "}
                  <img src={require("../assests/images/drop-arrow.png")} />
                </button>
                <div
                  className={
                    tenderMenuTab ? "dropcontent active" : "dropcontent"
                  }
                >
                  <Link
                    to="/corporate-office"
                    onClick={() => setMainMenuTab(false)}
                  >
                    CORPORATE OFFICE
                  </Link>
                  <Link
                    to="/gurgaon_plant_tenders"
                    onClick={() => setMainMenuTab(false)}
                  >
                    GURGAON PLANT
                  </Link>
                  <Link
                    to="/rishikesh_plant_tenders"
                    onClick={() => setMainMenuTab(false)}
                  >
                    RISHIKESH PLANT{" "}
                  </Link>
                  <Link
                    to="/chennai_plant_tenders"
                    onClick={() => setMainMenuTab(false)}
                  >
                    CHENNAI PLANT{" "}
                  </Link>
                  <Link
                    to="/odcl_plant_tenders"
                    onClick={() => setMainMenuTab(false)}
                  >
                    ODCL PLANT{" "}
                  </Link>
                  <Link
                    to="/hyderabad_plant_tenders"
                    onClick={() => setMainMenuTab(false)}
                  >
                    HYDERABAD PLANT
                  </Link>
                </div>
              </div>
              <div className="submenu">
                <button onClick={toggleMarketingMenuTab} className="submenubtn">
                  MARKETING{" "}
                  <img src={require("../assests/images/drop-arrow.png")} />
                </button>
                <div
                  className={
                    marketingMenuTab ? "dropcontent active" : "dropcontent"
                  }
                >
                  <Link
                    to="/regional-sales-offices"
                    onClick={() => setMainMenuTab(false)}
                  >
                    CORPORATE SALES OFFICE{" "}
                  </Link>
                  <Link
                    to="/south-zone-office-hyderabad"
                    onClick={() => setMainMenuTab(false)}
                  >
                    SOUTH ZONE OFFICE{" "}
                  </Link>
                  <Link
                    to="/east-zone-office-kolkata"
                    onClick={() => setMainMenuTab(false)}
                  >
                    {" "}
                    EAST ZONE OFFICE
                  </Link>
                  <Link
                    to="/north-zone-office-gurgaon"
                    onClick={() => setMainMenuTab(false)}
                  >
                    NORTH ZONE OFFICE
                  </Link>
                  <Link
                    to="/west-zone-office-mumbai"
                    onClick={() => setMainMenuTab(false)}
                  >
                    {" "}
                    WEST ZONE OFFICE
                  </Link>
                  <Link
                    to="/Lucknow-zone-office"
                    onClick={() => setMainMenuTab(false)}
                  >
                    {" "}
                    LUCKNOW ZONE OFFICE
                  </Link>
                </div>
              </div>
              <div className="submenu">
                <button onClick={toggleRtiMenuTab} className="submenubtn">
                  RTI {" "}<img src={require("../assests/images/drop-arrow.png")} />{" "}
                </button>
                <div
                  className={
                    rtiMenuTab ? "dropcontent active" : "dropcontent"
                  }
                >

                  <a href="../pdf/rti-act.pdf" target="_blank">
                    RTI Act, 2005
                  </a>
                  <a
                    href="../pdf/CPIO-&-PIO-as-on-09.04.2025.pdf"
                    target="_blank"
                  >
                    CPIO & PIO
                  </a>
                  <a
                    href="pdf/Disclosure-25.02.2025.pdf"
                    target="_blank"
                  >
                    {" "}
                    Disclosure under section 4(1)(b) of Right to Information
                    Act 2005.
                  </a>

                </div>
              </div>
              <div className="submenu">
                <button onClick={toggleProductMenuTab} className="submenubtn">
                  PRODUCTS{" "}
                  <img src={require("../assests/images/drop-arrow.png")} />{" "}
                </button>
                <div
                  className={
                    productMenuTab ? "dropcontent active" : "dropcontent"
                  }
                >
                  <a href="/pdf/In%20House%20Prod..pdf" target="_blank">
                    IN HOUSE PRODUCTS
                  </a>
                  <a href="/pdf/Therapeutical%20Categories.pdf" target="_blank">
                    THERAPEUTICAL PRODUCTS
                  </a>
                  <a
                    href="/pdf/Current-Product-Range-PPP-IDPL-01-03-15.pdf"
                    target="_blank"
                  >
                    IDPL GENERIC DRUGS (PPP)
                  </a>
                  <a
                    href="/pdf/Current-Product-Range-Non-PPP-IDPL-01-03-15.pdf"
                    target="_blank"
                  >
                    IDPL GENERIC DRUGS(Non PPP)
                  </a>
                </div>
              </div>
              <div className="submenu">
                <button className="submenubtn">
                  {" "}
                  <Link to="/career" onClick={() => setMainMenuTab(false)}>
                    CAREER
                  </Link>
                </button>
              </div>
              <div className="submenu">
                <button className="submenubtn">
                  {" "}
                  <Link to="/contact_us" onClick={() => setMainMenuTab(false)}>
                    CONTACT US
                  </Link>
                </button>
              </div>
            </nav>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
